// React
import React, { useRef, useEffect, useState } from "react";
// React
// CSS
import styles from "./QuestionModalForShowQuestion.module.css";
// CSS
// Modules
import Swal from "sweetalert2";
// Modules

type QuestionModalForShowQuestionProps = {
  questionImageUrl: string;
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const QuestionModalForShowQuestion: React.FunctionComponent<
  QuestionModalForShowQuestionProps
> = ({ questionImageUrl, setIsModalInScreen }) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);

  const closeModal = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    innerRef.current.style.top = "90vh";
    outerRef.current.style.opacity = "0";

    setTimeout(() => {
      setIsModalInScreen(false);
    }, 500);
  };

  useEffect(() => {
    Swal.fire({
      icon: "question",
      title: "نحوه ی کار",
      text: "برای بسته شدن روی هر قسمتی که خواستید دوبار ضربه بزنید و برای زوم کردن ، دست خود را از روی عکس به سمت پایین بکشید",
    });
    setTimeout(() => {
      if (!innerRef.current) return;
      if (!outerRef.current) return;

      innerRef.current.style.top = "0";
      outerRef.current.style.opacity = "0.7";
    }, 50);
  }, []);

  useEffect(() => {
    document.body.style.overscrollBehaviorY = "none";
    return () => {
      document.body.style.overscrollBehaviorY = "auto";
    };
  }, []);

  const [zoomLevel, setZoomLevel] = useState<number>(1);
  const [mouseX, setMouseX] = useState<number>(0);
  const [mouseY, setMouseY] = useState<number>(0);

  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    if (!innerRef.current) return;
    const touch = event.touches[0];
    setMouseX(touch.clientX);
    setMouseY(touch.clientY);
  };

  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    if (!innerRef.current) return;
    event.preventDefault();
    const touch = event.touches[0];
    const deltaY = touch.clientY - mouseY;
    const newZoomLevel = zoomLevel + deltaY / innerRef.current.offsetHeight;
    setZoomLevel(Math.max(1, newZoomLevel));
    setMouseX(touch.clientX);
    setMouseY(touch.clientY);
  };

  const handleTouchEnd = () => {
    setZoomLevel(1);
    setMouseX(0);
    setMouseY(0);
  };

  return (
    <div
      className={`${styles.questionModalContainer} fixed  w-screen h-screen top-0 left-0 flex items-center justify-center overflow-hidden `}
      onDoubleClick={closeModal}
    >
      <div
        className={`${styles.outer} fixed  w-screen h-screen left-0 top-0 `}
        ref={outerRef}
      ></div>
      <div
        className={`${styles.innerx} w-full   relative`}
        ref={innerRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={questionImageUrl}
          className={`${styles.questionImg} w-max  `}
          alt=""
          style={{
            transform: `scale(${zoomLevel})`,
            transformOrigin: `${mouseX}px ${mouseY}px`,
          }}
        />
      </div>
    </div>
  );
};

export default QuestionModalForShowQuestion;
